import { Injectable } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase';

import { Observable } from 'rxjs/Observable';

@Injectable()
export class FirebaseService {
	public current_user:firebase.User;

	constructor(
		public db: AngularFireDatabase,
		private auth: AngularFireAuth
	) {
		auth.authState.subscribe((user) => {
			this.current_user = user;
			console.log(this.current_user);
		})
	}

	/**
	 * User Login
	 * @param {object} user : User data
	 */
	userLogin(user) {
		return this.auth.auth.signInWithEmailAndPassword(user.email, user.password);;
	}

	userDBLogin(user){
		var to_return = this.db.object("/admins/"+user.uid) as FirebaseObjectObservable<Adminlist>;
		return to_return;
	}

	/**
	 * User Logout
	 */
	userLogout() {
		this.auth.auth.signOut().then(data => localStorage.removeItem('currentUser'));
	}

	/**
	 * Listen to any change on auth firebase
	 */
	realTimeListener() {
		this.auth.auth.onAuthStateChanged(firebaseUser => {
			if(firebaseUser){
				localStorage.setItem('currentUser', firebaseUser.email);
				console.log(firebaseUser);
			} else {
				console.log('ga login');
			}
			console.log('auth state berubah', firebaseUser);
		});
	}

	/**
	 * Get current logged in user
	 */
	getCurrentUser() {
		return this.current_user;
	}

	getAuth() {
		return this.auth.authState;
	}

	resetPassword(email){
		return this.auth.auth.sendPasswordResetEmail(email);
	}
	
}

export class Adminlist {
  $key?: string;
	uid?: string;
	email?: string = '';
	password?: string = '';
	fullname?: string = '';

	created_at?: number;
	updated_at?: number;

	constructor() {
		var now = new Date();
		this.created_at = now.getTime();
		this.updated_at = now.getTime();
	}

}


// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/services/firebase.service.ts